import React from "react";
import Hero_Section from "./Sections/Hero_Section";
import Popular_Categories from "./Sections/Popular_Categories";
import Our_Services from "./Sections/Our_Services";

import Buy_Sell_Products from "./Sections/Buy_Sell_Products";
import Our_Video from "./Sections/Our_Video";
import Our_Blog from "./Sections/Our_Blog";
import Comparisons from "./Sections/Comparisons";
import Counter from "./Sections/Counter";
import Latest_Product from "../../Components/common/Latest_Product";
import CompanyLogos from "./Sections/CompanyLogos";
import EnergyStore from "./Sections/EnergyBazzarStore";
// import BikeCompanyLogos from "./Sections/BikeCompanyLogos";
const Home = () => {
  return (
    <>
      <Hero_Section />
      <Popular_Categories />
      <CompanyLogos />
      <Our_Services />
      <Latest_Product />
      <EnergyStore/>
      {/* <BikeCompanyLogos/> */}
      {/* <Buy_Sell_Products /> */}
      <Our_Video />
      <Comparisons />
      <Our_Blog />
      <Counter />
    </>
  );
};

export default Home;
